import { getDefaultWallets } from "@rainbow-me/rainbowkit";
import { configureChains, createClient} from "wagmi";
import { alchemyProvider } from "wagmi/providers/alchemy";
import { publicProvider } from "wagmi/providers/public";
import { avalancheFuji, polygonMumbai, arbitrum, bsc, avalanche, polygon } from "@wagmi/core/chains";
import { createWagmiAdapter } from "x-bridge-layerzero";
import { jsonRpcProvider } from '@wagmi/core/providers/jsonRpc'




const moonbase = {
  id: 1287,
  name: "Moonbase Testnet",
  network: "moonbeam-testnet",
  nativeCurrency: {
    decimals: 18,
    name: "Dev",
    symbol: "DEV"
  },
  rpcUrls: {
    default: {
      http: ["https://rpc.api.moonbase.moonbeam.network"],
      webSocket: ["wss://wss.api.moonbase.moonbeam.network"]
    },
    public: {
      http: ["https://rpc.api.moonbase.moonbeam.network"],
      webSocket: ["wss://wss.api.moonbase.moonbeam.network"]
    }
  },
  blockExplorers: {
    default: {
      name: "Moonscan",
      url: "https://moonbase.moonscan.io"
    },
    etherscan: {
      name: "Moonscan",
      url: "https://moonbase.moonscan.io"
    }
  },
  testnet: true
}; 


const moonbeam = {
  id: 1284,
  name: "Moonbeam",
  network: "moonbeam",
  nativeCurrency: {
    decimals: 18,
    name: "Moonbeam",
    symbol: "GLMR"
  },
  rpcUrls: {
    public: {
      http: ["https://moonbeam.public.blastapi.io"],
      webSocket: ["wss://moonbeam.public.blastapi.io"]
    },
    default: {
      http: ["https://moonbeam.public.blastapi.io"],
      webSocket: ["wss://moonbeam.public.blastapi.io"]
    }
  },
  blockExplorers: {
    default: {
      name: "Moonscan",
      url: "https://moonscan.io"
    },
    etherscan: {
      name: "Moonscan",
      url: "https://moonscan.io"
    }
  },
  testnet: false
};

const shibuya = {
  id: 81,
  name: "Astar Testnet",
  network: "astar-testnet",
  nativeCurrency: {
    decimals: 18,
    name: "Sby",
    symbol: "SBY"
  },
  rpcUrls: {
    default: {
      http: ["https://evm.shibuya.astar.network"],
      webSocket: ["wss://rpc.shibuya.astar.network"]
    },
    public: {
      http: ["https://evm.shibuya.astar.network"],
      webSocket: ["wss://rpc.shibuya.astar.network"]
    }
  },
  blockExplorers: {
    default: {
      name: "Blockscout",
      url: "https://blockscout.com/shibuya"
    },
    etherscan: {
      name: "Blockscout",
      url: "https://blockscout.com/shibuya"
    }
  },
  testnet: true
}; 

const zkatana = {
  id: 1261120,
  name: "zKatana Testnet",
  network: "zkatana-testnet",
  nativeCurrency: {
    decimals: 18,
    name: "ETH",
    symbol: "ETH"
  },
  rpcUrls: {
    default: {
      http: ["https://rpc.startale.com/zkatana"],
      webSocket: ["wss://ws.zkatana.gelato.digital"]
    },
    public: {
      http: ["https://rpc.startale.com/zkatana"],
      webSocket: ["wss://ws.zkatana.gelato.digital"]
    }
  },
  blockExplorers: {
    default: {
      name: "Blockscout",
      url: "https://zkatana.explorer.startale.com"
    },
    etherscan: {
      name: "Blockscout",
      url: "https://zkatana.explorer.startale.com"
    }
  },
  testnet: true
}; 

const Metis = {
  id: 1088,
  name: "Metis",
  network: "andromeda",
  nativeCurrency: {
    decimals: 18,
    name: "Metis",
    symbol: "METIS"
  },
  rpcUrls: {
    default: { http: ["https://andromeda.metis.io/?owner=1088"] },
    public: { http: ["https://andromeda.metis.io/?owner=1088"] }
  },
  blockExplorers: {
    default: {
      name: "Andromeda Explorer",
      url: "https://andromeda-explorer.metis.io"
    }
  },
  testnet: false
};

const baseSepolia = {
  id: 84532,
  network: "base-sepolia",
  name: "Base Sepolia",
  nativeCurrency: { name: "Base Sepolia", symbol: "ETH", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://base-sepolia.blockscout.com"]
    },
    public: {
      http: ["https://base-sepolia.blockscout.com"]
    }
  },
  blockExplorers: {
    etherscan: {
      name: "Blockscout",
      url: "https://base-sepolia.blockscout.com"
    },
    default: {
      name: "Blockscout",
      url: "https://base-sepolia.blockscout.com"
    }
  },
  testnet: true
};

const base = {
  id: 8453,
  network: "base",
  name: "Base",
  nativeCurrency: { name: "Base", symbol: "ETH", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://mainnet.base.org"]
    },
    public: {
      http: ["https://mainnet.base.org"]
    }
  },
  blockExplorers: {
    blockscout: {
      name: "Basescout",
      url: "https://base.blockscout.com"
    },
    default: {
      name: "Basescan",
      url: "https://basescan.org"
    },
    etherscan: {
      name: "Basescan",
      url: "https://basescan.org"
    }
  },
  testnet: false
};


const polygonZkEvmTestnet = {
  id: 1442,
  name: "Polygon zkEVM Testnet",
  network: "polygon-zkevm-testnet",
  nativeCurrency: { name: "Ether", symbol: "ETH", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://rpc.public.zkevm-test.net"]
    },
    public: {
      http: ["https://rpc.public.zkevm-test.net"]
    }
  },
  blockExplorers: {
    blockscout: {
      name: "Blockscout",
      url: "https://explorer.public.zkevm-test.net"
    },
    default: {
      name: "PolygonScan",
      url: "https://testnet-zkevm.polygonscan.com"
    }
  },
  testnet: true,
};


const polygonZkEvm = {
  id: 1101,
  name: "Polygon zkEVM",
  network: "polygon-zkevm",
  nativeCurrency: { name: "Ether", symbol: "ETH", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://zkevm-rpc.com"]
    },
    public: {
      http: ["https://zkevm-rpc.com"]
    }
  },
  blockExplorers: {
    default: {
      name: "PolygonScan",
      url: "https://zkevm.polygonscan.com"
    }
  },
  testnet: false,
};

const zkSync = {
  id: 324,
  name: "zkSync Era",
  network: "zksync-era",
  nativeCurrency: {
    decimals: 18,
    name: "Ether",
    symbol: "ETH"
  },
  rpcUrls: {
    default: {
      http: ["https://mainnet.era.zksync.io"],
      webSocket: ["wss://mainnet.era.zksync.io/ws"]
    },
    public: {
      http: ["https://mainnet.era.zksync.io"],
      webSocket: ["wss://mainnet.era.zksync.io/ws"]
    }
  },
  blockExplorers: {
    default: {
      name: "zkExplorer",
      url: "https://explorer.zksync.io"
    }
  },
};

const zkSyncTestnet = {
  id: 280,
  name: "zkSync Era Testnet",
  network: "zksync-era-testnet",
  nativeCurrency: { name: "Ether", symbol: "ETH", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://testnet.era.zksync.dev"],
      webSocket: ["wss://testnet.era.zksync.dev/ws"]
    },
    public: {
      http: ["https://testnet.era.zksync.dev"],
      webSocket: ["wss://testnet.era.zksync.dev/ws"]
    }
  },
  blockExplorers: {
    default: {
      name: "zkExplorer",
      url: "https://goerli.explorer.zksync.io"
    }
  },
  testnet: true
};


const { chains: wagmiChains, provider } = configureChains(
  // provide wagmi chain configuration
  [polygonMumbai, avalancheFuji, moonbase, baseSepolia, shibuya, zkatana],
  [alchemyProvider({ apiKey: process.env.ALCHEMY_ID! }), 
   // jsonRpcProvider({ rpc: () => ({ http: "https://rpc.api.moonbase.moonbeam.network" }) }),  //<<<< New RPC Provider
  // jsonRpcProvider({ rpc: () => ({ http: "https://mainnet.base.org" }) }),  //<<<< New RPC Provider
   publicProvider()]
);



const { connectors } = getDefaultWallets({
  appName: "My RainbowKit App",
  chains: wagmiChains,
});

const wagmiClient = createClient({
  autoConnect: true,
  connectors,
  provider,
});

const wagmiAdapter = createWagmiAdapter(wagmiClient as any);

export const wagmi = {
  wagmiClient,
  wagmiChains,
  wagmiAdapter,
};

